export default {
  title: 'Richiedi fattura',
  form: {
    is_receipt_required: {
      label: 'Richiedi fattura via email',
    },
    company_name: {
      placeholder: 'Nome azienda (opzionale)',
    },
    first_name: {
      placeholder: 'Nome',
    },
    last_name: {
      placeholder: 'Cognome',
    },
    address: {
      placeholder: 'Via + numero',
    },
    zip_code: {
      placeholder: 'CAP',
    },
    city: {
      placeholder: 'Città',
    },
    tax_id: {
      placeholder: 'Partita IVA',
    },
    email: {
      placeholder: 'Indirizzo email',
    },
  },
};
